module.exports = __webpack_public_path__ + "static/parcelboundary-5bba317ea1b577eed32a29c39e7dd55c.gif";